namespace TabAurous.Production {
    export interface MergingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        BagNo?: string;
        DepartmentId?: number;
        UserId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NoOfSubBag?: number;
        EachSubBagPieces?: number;
        EachSubBagParts?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: MergingItemsRow[];
    }

    export namespace MergingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.Merging';
        export const deletePermission = 'Production:Merging:Delete';
        export const insertPermission = 'Production:Merging:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Merging:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            BagNo = "BagNo",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NoOfSubBag = "NoOfSubBag",
            EachSubBagPieces = "EachSubBagPieces",
            EachSubBagParts = "EachSubBagParts",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details"
        }
    }
}
